import Link from '@tiptap/extension-link';
import Table from '@tiptap/extension-table';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import TableRow from '@tiptap/extension-table-row';
import StarterKit from '@tiptap/starter-kit';

import { isValidEditorLinkHref } from './normalizeEditorLinkUrl.js';

/**
 * @param {{ openOnClick: boolean }} options
 * @returns {import('@tiptap/extension-link').Link}
 */
export function createLinkExtension({ openOnClick }) {
  return Link.configure({
    autolink: true,
    defaultProtocol: 'https',
    HTMLAttributes: {
      rel: 'noopener noreferrer',
      target: '_blank',
    },
    linkOnPaste: true,
    openOnClick,
    validate: (href) => isValidEditorLinkHref(href),
  });
}

/** @type {import('@tiptap/core').Extensions} */
export const tableEditorExtensions = [
  Table.configure({
    resizable: true,
  }),
  TableRow,
  TableCell,
  TableHeader,
];

/**
 * Shared TipTap extensions for editable and read-only editors (excluding Placeholder).
 * @param {{ openLinkOnClick: boolean }} options
 * @returns {import('@tiptap/core').Extensions}
 */
export function createBaseEditorExtensions({ openLinkOnClick }) {
  return [StarterKit, createLinkExtension({ openOnClick: openLinkOnClick }), ...tableEditorExtensions];
}
